import { STATUS_OPTIONS } from './constants';

export function getValue(orderStatusId: number) {
  return STATUS_OPTIONS.find((option) => option.value === orderStatusId);
}
